import SET_CURRENT_PAGE from '@data/constants/actionTypes/currentPage';

const setCurrentPage = value => ({
  type: SET_CURRENT_PAGE,
  value,
});

export default setCurrentPage;
